import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import './Theam.less';

class ColorSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            color: '',
            key: props.objKey,
            displayColorPicker: "none",
        };
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidUpdate() {
        let color = this.state.color;
        if (this.state.displayColorPicker === 'none' && this.props.color && color !== this.props.color) {
            this.setColor(this.props.color);
        }
    }
    setColor(color) {
        this.setState({ color })
    }
    handleClick = () => {
        this.props.onClick();
        let { displayColorPicker, key, color } = this.state;
        displayColorPicker = displayColorPicker === "none" ? "block" : "none";
        this.setState({ displayColorPicker }, () => {
            if (displayColorPicker === 'none') {
                this.props.closeColorSelect(key, color)
                // this.props.updateColor();
            }
        });
    }
    handleChange = (value) => {
        let {key} = this.state;
        let color = value.hex;
        this.setState({ color })
        this.props.onChange(key, color);
    }
    render() {
        let { color, displayColorPicker } = this.state;
        return (
            <div className="color-picker">
                <span onClick={this.handleClick} style={{ background: color }} className="color-button" />
                {displayColorPicker === "block" ?
                    <div
                        onClick={this.handleClick}
                        style={{
                            background: 'black',
                            opacity: 0.2,
                            width: '100%',
                            height: '100%',
                            left: '0px',
                            top: '0px',
                            zIndex: '10',
                            position: 'fixed'
                        }}
                    >关闭</div>
                    : null
                }
                {displayColorPicker === "block" ?
                    <div id="sketchPicker" style={{ position: "absolute", zIndex: 66 }}>
                        <SketchPicker color={color} disableAlpha onChange={this.handleChange} />
                    </div>
                    : null
                }
            </div>
        );
    }
}

export default ColorSelect;